import { Directive, Input } from '@angular/core';
import { FormControl, NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[appValorMinimo]',
  providers: [{provide: NG_VALIDATORS, useExisting: ValorMinimoDirective, multi: true}]
})
export class ValorMinimoDirective implements Validator {

  @Input('appValorMinimo') valorMinimo: number;

  constructor() { }

  validate(control: AbstractControl): {[key: string]: any} | null {
    if (control.value == null || Number(control.value < this.valorMinimo)) {
      return { erro: 'Valor inválido' };
    }

    return null;
  }

}
